import { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Form, Button, ButtonGroup } from "react-bootstrap";
import {
  inputErrorHandler,
  signalTransitionSuccess,
  signalTransitionError,
  removeEmptyValues,
  CloseBtn,
  PagingOptions,
  CORE_MODULE,
  VEHICLE_COMPONENT_ENTITY,
} from "../../utils";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "font-awesome/css/font-awesome.css";
import "tempusdominus-bootstrap/build/css/tempusdominus-bootstrap.css";
import {
  createComponent,
  resetCreateComponent,
  fetchComponent,
} from "../../store/actions/vehicle";
import { hideModalDialog } from "../../store/actions/dialog";
import { HasAccess } from "../../components/Access";
import ColumnText from "../../components/Column";
import { Link } from "react-router-dom";

class ComponentAddScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        component_name: "",
      },

      errors: {
        component_name: "",
      },
      reset: {
        fields: {
          component_name: "",
        },
        errors: {
          component_name: "",
        },
      },
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (this.props.createData.success) {
      this.props.dispatch(resetCreateComponent());
      let data = {};
      data.attrs = {};
      data.attrs["order_by"] = {};
      data.attrs.order_by["-desc"] = "me.id";
      data.conds = {};
      data.page = 1;
      data.page_size = PagingOptions.sizePerPage;
      this.props.dispatch(fetchComponent(data));
      this.props.dispatch(hideModalDialog());
      this.resetHandler();
      signalTransitionSuccess("Erfolgreich hinzugefügt");
    } else if (this.props.createData.error) {
      this.props.dispatch(resetCreateComponent());
      if (this.props.createData.rows.errorType === "UNIQUENESS") {
        let newErrors = {};
        newErrors["component_name"] = "Please Enter Unique Component";
        this.setState({ errors: newErrors });
      } else {
        signalTransitionError("Hinzufügen fehlgeschlagen");
      }
    }
  }

  resetHandler(evt) {
    this.setState({ fields: this.state.reset.fields });
    this.setState({ errors: this.state.reset.errors });
  }

  submitHandler(evt) {
    evt.preventDefault();
    // get our new errors

    let fields = this.state.fields;
    let newErrors = {};
    newErrors["component_name"] = inputErrorHandler(
      "",
      fields.component_name,
      true
    );
    let errors = removeEmptyValues(newErrors);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors: errors });
    } else {
      let compData = { component: {} };
      compData.component.name = fields.component_name;
      this.props.dispatch(createComponent(compData));
    }
  }

  changeHandler(evt, name) {
    let value = evt.target.value;
    this.setState((prevState) => ({
      fields: {
        ...prevState.fields,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: null,
      },
    }));
  }

  closeHandler = () => {
    this.props.dispatch(hideModalDialog());
  };

  render() {
    return (
      <div
        id="flyoutMenu"
        className={
          this.props.dialogData.modalDialog &&
          this.props.dialogData.modalName === "Component-Add"
            ? "show"
            : "hide"
        }
      >
        <Link
          to={"#"}
          onClick={() => {
            this.closeHandler();
          }}
        >
          <CloseBtn />
        </Link>
        <h5>neue Komponente anlegen</h5>
        <Form>
          <Form.Group controlId="component_name">
            <Form.Label>
              <ColumnText
                Module={CORE_MODULE}
                Entity={VEHICLE_COMPONENT_ENTITY}
                Label={"name"}
              />
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Komponentenname"
              name="component_name"
              value={this.state.fields.component_name}
              onChange={(evt) => this.changeHandler(evt, "component_name")}
              onKeyPress={this.onKeyPress}
              isInvalid={!!this.state.errors.component_name}
            />
            <Form.Control.Feedback type="invalid">
              {this.state.errors.component_name}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="modal-frm-btn">
            <Button
              type="Button"
              className="btn btn-dark Button"
              onClick={(evt) => this.submitHandler(evt)}
            >
              OK
            </Button>
            <Button
              type="Button"
              className="btn btn-dark"
              onClick={(evt) => this.resetHandler(evt)}
            >
              Abbrechen
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

ComponentAddScreen.propTypes = {};
ComponentAddScreen.defaultProps = {};

const mapStateToProps = (state) => ({
  localeData: state.Locale.localeData,
  createData: state.Component.createData,
  dialogData: state.Dialog.dialogData,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

// We normally do both in one step, like this:
export default connect(mapStateToProps, mapDispatchToProps)(ComponentAddScreen);
